import styled from "styled-components";

export const CounterCardWrapper = styled.div`
  .content h2,
  .content p {
    margin: 0;
  }
`;
